import { ContentPage } from 'designsystem/components/5-templates/ContentPage';
import { AlertsFeature } from 'features/Modules/Alerts';
import { SingleContentSectionFeature } from 'features/Modules/ContentSection/SingleContentSectionFeature';
import { ModuleFeature } from 'features/Modules/DynamicModule';
import { TopBannerFeature } from 'features/Modules/TopBanner';
import { useEffect, useState } from 'react';

export const CampaignPageFeature: React.FC<Content.CampaignPage> = ({ properties, children, additionalTop, additionalPageContent }) => {
	const { pageHeader, pageSection, pageSections, alertContent, bannerContent } = properties ?? {};
	const hasLanguagePicker = additionalTop?.languageBar || !!additionalPageContent;

	const [hasFullWidthLanguageBar, setHasFullWidthLanguageBar] = useState(false);
	const [hasFullWidthBanner, setHasFullWidthBanner] = useState(false);
	const [hasFullWidthHeader, setHasFullWidthHeader] = useState(false);

	useEffect(() => {
		const heroImage = bannerContent?.items?.[0] as unknown as Content.HeroImage;
		const heroImagefullwidthImage = heroImage?.content.properties.fullWidthImage;
		const pageHeaderfullwidthImage = pageHeader?.items?.[0]?.settings?.properties.fullWidthImage;

		setHasFullWidthBanner(heroImagefullwidthImage);
		setHasFullWidthHeader(pageHeaderfullwidthImage);

		if (heroImagefullwidthImage === undefined && pageHeaderfullwidthImage === true) {
			setHasFullWidthLanguageBar(true);
		} else if (heroImagefullwidthImage === true) {
			setHasFullWidthLanguageBar(true);
		}
	}, [bannerContent?.items, pageHeader?.items]);

	return (
		<ContentPage
			alerts={alertContent?.items?.length > 0 && <AlertsFeature alertContent={alertContent} />}
			additionalTop={additionalTop}
			additionalTopSettings={{
				fullWidth: {
					hasFullWidthLanguageBar: hasFullWidthLanguageBar,
					hasFullWidthBanner: hasFullWidthBanner,
					hasFullWidthHeader: hasFullWidthHeader,
				},
			}}
			additionalPageContent={additionalPageContent}
			topBanner={bannerContent?.items?.length > 0 && <TopBannerFeature bannerContent={bannerContent} />}
			header={
				pageHeader?.items?.length > 0 &&
				pageHeader.items.map((headerModule, index) => (
					<ModuleFeature
						key={index}
						contentModule={headerModule}
						additionalProps={hasLanguagePicker ? { noTopMargin: true } : undefined}
						// className={hasLanguagePicker ? 'u-top-margin-important--none' : index === 0 ? 'u-top-margin-important--lg' : ''}
					/>
				))
			}
		>
			{children}
			<SingleContentSectionFeature pageSection={pageSection?.items} />
			{pageSections?.items?.map((pageSectionItems, index) => (
				<SingleContentSectionFeature key={index + 'PageSection'} pageSection={pageSectionItems.content.properties.content?.items} />
			))}
		</ContentPage>
	);
};
